<div class="hk">
  <div class="halvany" *ngIf="betolt">Betöltés…</div>
  <p class="hk-hiba" *ngIf="hiba">{{ hiba }}</p>

  <ng-container *ngIf="adat">
    <div class="hk-biz">
      <b>{{ adat.tetel.szamlaszam || adat.tetel.bizonylatszam || 'Bizonylat' }}</b>
      <span *ngIf="adat.tetel.partner_nev"> · {{ adat.tetel.partner_nev }}</span>
      <span> · {{ adat.tetel.datum }}</span>
      <span> · nettó {{ adat.tetel.netto | number:'1.0-0' }} Ft</span>
    </div>

    <div class="hk-kotesek" *ngIf="adat.kotesek.length">
      <div class="halvany">Már kötve:</div>
      <div class="hk-kotes" *ngFor="let k of adat.kotesek">
        <span class="cimke" [class.zold]="k.tipus === 'bevetel'">{{ k.tipus === 'bevetel' ? 'bérleti díj' : 'kiadás' }}</span>
        <b>{{ k.eszkoz_nev }}</b><span *ngIf="k.osa_sor"> · {{ k.osa_sor }}. sor</span>
        <span> · {{ (adat.afa_alany ? k.netto : k.brutto) | number:'1.0-0' }} Ft</span>
        <button type="button" class="kv-mini" title="Kötés törlése" (click)="kotesTorol(k)"><ion-icon name="trash-outline"></ion-icon></button>
      </div>
    </div>

    <p class="halvany" *ngIf="!adat.eszkozok.length">Ennek az ügyfélnek még nincs tárgyi eszköze – előbb a Tárgyi eszköz modulban vedd fel.</p>

    <ng-container *ngIf="adat.eszkozok.length">
      <label class="kv-mezo"><span>Tárgyi eszköz</span>
        <select [(ngModel)]="eszkozId">
          <option [ngValue]="null">– válassz –</option>
          <option *ngFor="let e of adat.eszkozok" [ngValue]="e.id">{{ e.leltari_szam ? e.leltari_szam + ' – ' : '' }}{{ e.megnevezes }}{{ e.kivezetes_datum ? ' (kivezetve)' : '' }}</option>
        </select></label>

      <div class="hk-valaszto">
        <label><input type="radio" name="hk-tipus" value="bevetel" [(ngModel)]="tipus"> Bérleti díj (bevétel)</label>
        <label><input type="radio" name="hk-tipus" value="kiadas" [(ngModel)]="tipus"> Kiadás (nem aktivált: javítás, biztosítás…)</label>
      </div>

      <div class="hk-valaszto" *ngIf="adat.nav_sorok.length">
        <label><input type="radio" name="hk-mod" value="egesz" [(ngModel)]="mod"> A teljes számla</label>
        <label><input type="radio" name="hk-mod" value="sorok" [(ngModel)]="mod"> Csak kiválasztott sorai</label>
      </div>

      <ng-container *ngIf="mod === 'egesz'">
        <p class="hk-figy" *ngIf="egeszKotve.length">Ez a bizonylat egészében már kötve van – ha csak egy része tartozik ide, töröld a régi kötést.</p>
        <label class="kv-mezo"><span>Megnevezés</span><input type="text" [(ngModel)]="megnevezes"></label>
        <div class="hk-osszeg">
          <label class="kv-mezo"><span>Nettó</span><input type="number" [(ngModel)]="osszeg.netto"></label>
          <label class="kv-mezo"><span>ÁFA</span><input type="number" [(ngModel)]="osszeg.afa"></label>
          <label class="kv-mezo"><span>Bruttó</span><input type="number" [(ngModel)]="osszeg.brutto"></label>
        </div>
        <p class="halvany" style="font-size:12px;margin:0">A kimutatás {{ adat.afa_alany ? 'a nettó' : 'a bruttó (alanyi mentes ügyfél)' }} összeggel számol. Ha a számlának csak egy része tartozik ide, írd át.</p>
      </ng-container>

      <div class="tabla-wrap" *ngIf="mod === 'sorok'" style="margin:0">
        <table class="n-racs">
          <thead><tr><th></th><th>#</th><th>Megnevezés</th><th class="num">Nettó</th><th class="num">Bruttó</th></tr></thead>
          <tbody>
            <tr *ngFor="let s of adat.nav_sorok" [class.hk-kotott]="sorKotve(s.sorszam)">
              <td><input type="checkbox" [disabled]="!!sorKotve(s.sorszam)" [checked]="kijelolt.has(s.sorszam)" (change)="sorValt(s, $any($event.target).checked)"></td>
              <td>{{ s.sorszam }}</td>
              <td>{{ s.megnevezes }}<span class="halvany" *ngIf="sorKotve(s.sorszam) as k"> · már kötve: {{ k.eszkoz_nev }}</span></td>
              <td class="num">{{ s.netto | number:'1.0-0' }}</td><td class="num">{{ s.brutto | number:'1.0-0' }}</td>
            </tr>
          </tbody>
          <tfoot><tr><td colspan="3">Kiválasztva ({{ kijelolt.size }} sor)</td><td class="num" colspan="2"><b>{{ kijeloltOsszeg | number:'1.0-0' }} Ft</b></td></tr></tfoot>
        </table>
      </div>

      <div class="nk-lab">
        <button type="button" class="ov-gomb fo" [disabled]="!mentheto" (click)="ment()">
          <ion-icon name="link-outline"></ion-icon>{{ mentes ? 'Mentés…' : 'Hozzárendelés az eszközhöz' }}</button>
      </div>
    </ng-container>
  </ng-container>
</div>
